module.exports = __webpack_public_path__ + "img/1_top2.d2d156e8.png";